export default "__VITE_ASSET__Dwot1XkF__"